import React, { Component } from 'react'
import { Table } from 'reactstrap'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { openModalWithContainer } from './../reducers/modals'
import Resource from '../Resource'

// import '../styles/SettingsContainer.css'

const Headers = [
  {
    label: 'Name',
    key: 'firstName',
  },
  {
    label: 'User Name',
    key: 'username',
  },
  { label: 'Email', key: 'email' },
  { label: 'Assigned Category', key: 'assignedSectionId' },
  { label: 'Videos Watched', key: 'videosWatched' },
  { label: 'Last Video Watched', key: 'lastVideoDate' },
  { label: 'Role', key: 'role' },
  { label: 'Trainer', key: 'trainerId' },
  { label: 'Actions', key: '' },
]

export default class UsersContainer extends Component {
  state = {
    sortAttr: 'firstName',
    sortDir: 'DESC',
  }

  render() {
    const { sortAttr, sortDir } = this.state
    const { me } = this.props

    const inviteURL =
      window.location.protocol + '//' + window.location.host + '/join'

    const sortUsers = (users) => {
      let filteredUsers = users
      if (this.props.me.role === 2) {
        filteredUsers = users.filter((user) => user.trainerId === this.props.me.id)
      }
      return filteredUsers.sort((a, b) => {
        const r =
          typeof a[sortAttr] === 'string'
            ? `${a[sortAttr]}`.localeCompare(`${b[sortAttr]}`)
            : b[sortAttr] - a[sortAttr]
        return sortDir === 'ASC' ? -r : r
      })
    }

    const mapRoleLabel = (roleId) => {
      switch (roleId) {
        case 1:
          return 'Admin'
        case 2:
          return 'Trainer'
        case 3:
        default:
          return 'User'
      }
    }
    const renderHeader = ({ key, label }) => {
      return (
        <th
          key={key}
          onClick={() => {
            if (sortAttr === key) {
              this.setState({ sortAttr, sortDir: sortDir === 'ASC' ? 'DESC' : 'ASC' })
            } else {
              this.setState({ sortAttr: key, sortDir: 'DESC' })
            }
          }}
        >
          {label}
          <div style={{ float: 'right' }}>
            {sortAttr === key ? (sortDir === 'ASC' ? '⬆' : '⬇') : ''}
          </div>
        </th>
      )
    }

    return (
      <Resource collection path={['sections']} placeholder={[]}>
        {(sections) => (
          <Resource collection path={['users']} placeholder={[]}>
            {(users, { onUpdateItem, onDeleteItem, dispatch }) => (
              <div id="UsersContainer">
                <h3 className="tab-header">Participants</h3>
                <p style={{ marginTop: 20, marginBottom: 30 }}>
                  Invite participants to join the EL-FIT study using this invitation link:
                  <input className="form-control" type="text" value={inviteURL} readOnly />
                </p>
                <Table className="table-element">
                  <thead>
                    <tr>{Headers.map(renderHeader)}</tr>
                  </thead>
                  <tbody>
                    {sortUsers(users).map((user) => (
                      <tr key={user.id}>
                        <td>
                          <Link to={`/users/${user.id}`}>
                            {user.firstName} {user.lastName}
                          </Link>
                        </td>
                        <td>{user.username}</td>
                        <td>{user.email}</td>
                        <td>
                          {(sections.find((s) => s.id === user.assignedSectionId) || {}).title}
                        </td>
                        <td>{user.videosWatched}</td>
                        <td>
                          {user.lastVideoDate ? moment(user.lastVideoDate).fromNow() : 'Never'}
                        </td>
                        <td>
                          {/* todo - this should be dynamic */}
                          {mapRoleLabel(user.role)}
                        </td>
                        <td>{user.trainerName}</td>
                        <td>
                          <a
                            href="#"
                            onClick={() =>
                              dispatch(
                                openModalWithContainer('UserContainer', {
                                  user: user,
                                  sections: sections,
                                  onDelete: onDeleteItem,
                                  onSave: onUpdateItem,
                                  trainers: users.filter((user) => user.role === 2),
                                  me: me,
                                })
                              )
                            }
                          >
                            Edit
                          </a>
                          {` | `}
                          <Link to={`/users/${user.id}`}>View</Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Resource>
        )}
      </Resource>
    )
  }
}
